import Controller from "./backupSchedule.controller";
import template from "./backupSchedule.html";

const backupSchedule = {
  template,
  controller: Controller,
};

export default backupSchedule;



// WEBPACK FOOTER //
// ./src/pages/backupSchedule/backupSchedule.component.js